// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import calendarDateIcon from "@/assets/icons/calendar-date.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CalendarDateIconProps = Omit<IconProps, "name">;

export function CalendarDateIcon(props: CalendarDateIconProps): React.ReactNode {
  return <Icon name={calendarDateIcon} {...props} />;
}
